module.exports = __webpack_public_path__ + "img/bg_img.e621b063.jpg";